import React from 'react';

import Helmet from './Helmet';

const Title = 'Spekit Case Study | Canny';
const Description = 'Learn how Spekit uses Canny to make data-backed product decisions.';
const Image = 'https://canny-assets.io/images/5bd4908e2b2863da603777ec113526e2.png';

const SpekitLandingHelmet = () => {
  return (
    <Helmet
      title={Title}
      meta={[
        { name: 'description', content: Description },

        { property: 'og:image', content: Image },
        { property: 'og:title', content: Title },
        { property: 'og:description', content: Description },
        { property: 'og:url', content: 'https://canny.io/case-studies/spekit' },
        { property: 'og:type', content: 'website' },

        { name: 'twitter:card', content: 'summary_large_image' },
        { name: 'twitter:site', content: '@cannyHQ' },
        { name: 'twitter:title', content: Title },
        { name: 'twitter:description', content: Description },
        { name: 'twitter:image', content: Image },
      ]}
    />
  );
};

export default SpekitLandingHelmet;
